import { FormikProps } from "formik";

import Icon from "assets/icons";
import FormContainer from "shared/form";
import Variant from "shared/enums/Variant";
import Button from "shared/components/button";
import ButtonType from "shared/enums/ButtonTypes";
import { useCopies } from "shared/hooks/useCopies";
import { getFormattedCurrency } from "shared/utils";
import { BulkTicketQuantityFormPropTypes } from "./types";
import { useBulkTicketQuantityFormService } from "./service";
import FormSelectDropdownField from "shared/form/fields/selectDropdown";

function BulkTicketQuantityForm(props: BulkTicketQuantityFormPropTypes) {
  const copies = useCopies();
  const service = useBulkTicketQuantityFormService(props);

  return (
    <FormContainer
      onSubmit={service.submitHandler}
      initialValues={service.initialValues}
      validationSchema={service.validationSchema}
      enableReinitialize>
      {({ values, errors, setFieldValue }: FormikProps<typeof service.initialValues>) => (
        <FormContainer.Form className="buyInventory_qtySelection">
          <div className="buyInventory_qtySelectionForm">
            <div className="buyInventory_qtySelectionWrapper buyInventory_qtySelectionCard">
              <div className="buyInventory_qtySelection--dropdown">
                <FormSelectDropdownField
                  required
                  name={"quantity"}
                  options={service.quantityOptions}
                  label={copies.get("number.of.tickets")}
                  onChange={({ value }) => service.quantityChangeHandler(value)}
                />
              </div>
              <div className="buyInventory_qtySelection_rate">
                <label className="buyInventory_qtySelection_rate--label">{copies.get("rate")}</label>
                {values.quantity && !errors.quantity ? (
                  <p className="buyInventory_qtySelection_rate--value">
                    {getFormattedCurrency(service.getApplicableMeetingPrice(values.quantity))}
                  </p>
                ) : (
                  copies.get("empty.cell")
                )}
              </div>
              <div className="buyInventory_qtySelection_total">
                <label className="buyInventory_qtySelection_total--label">{copies.get("total.amount")}</label>
                {values.quantity && !errors.quantity ? (
                  <p className="buyInventory_qtySelection_total--value">
                    {service.getApplicableTotalPrice(values.quantity)}
                  </p>
                ) : (
                  copies.get("empty.cell")
                )}
              </div>
            </div>
            <div className="buyInventory_qtySelection_action">
              {service.isInvoicePaymentPending && service.isQuantityChanged && (
                <p className="buyInventory_qtySelection_actionReset">
                  <Icon.InfoCircleThick />
                  {copies.get("invoice.payment.buy.meetings.already.requested.modify")}
                  <Button
                    icon={<Icon.Refresh />}
                    label={copies.get("reset")}
                    variant={Variant.LINK}
                    onClick={() => {
                      setFieldValue("quantity", service.initialValues.quantity);
                      service.setIsQuantityChanged(false);
                    }}
                  />
                </p>
              )}
              <Button
                type={ButtonType.SUBMIT}
                disabled={Boolean(errors.quantity)}
                label={copies.get("proceed")}
                icon={<Icon.ArrowRightLong />}
                iconPositionRight
              />
            </div>
          </div>
        </FormContainer.Form>
      )}
    </FormContainer>
  );
}

export default BulkTicketQuantityForm;
